

import React, { Suspense } from 'react';
import { Loader } from 'lucide-react';

const ChartContent = React.lazy(() => import('./ChartContent'));

interface ChartWidgetProps {
  title: string;
  subtitle?: string;
  type: 'line' | 'bar' | 'pie';
  data: any[];
  dataKeys: Array<{
    key: string;
    color: string;
    label: string;
  }>;
  loading?: boolean;
  height?: number;
}

export function ChartWidget({
  title,
  subtitle,
  type,
  data,
  dataKeys,
  loading = false,
  height = 300,
}: ChartWidgetProps) {
  if (loading) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-4 sm:p-6">
        <h3 className="font-semibold text-sm sm:text-base mb-2">{title}</h3>
        {subtitle && <p className="text-xs text-gray-500 mb-4">{subtitle}</p>}
        <div className="flex items-center justify-center" style={{ height }}>
          <Loader className="w-6 h-6 text-gray-400 animate-spin" />
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-4 sm:p-6">
        <h3 className="font-semibold text-sm sm:text-base mb-2">{title}</h3>
        {subtitle && <p className="text-xs text-gray-500 mb-4">{subtitle}</p>}
        <div className="flex items-center justify-center" style={{ height }}>
          <p className="text-sm text-gray-500">No data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 sm:p-6">
      <div className="mb-4">
        <h3 className="font-semibold text-sm sm:text-base">{title}</h3>
        {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
      </div>

      <Suspense fallback={<div className="flex items-center justify-center" style={{ height }}><Loader className="w-6 h-6 text-gray-400 animate-spin" /></div>}>
        <ChartContent type={type} data={data} dataKeys={dataKeys} height={height} />
      </Suspense>
    </div>
  );
}
